export default __webpack_public_path__ + "static/media/CHN.39ff556e.svg";